export default __webpack_public_path__ + "static/media/odisha-mining-and-infrastructure-international-expo-2024.1cead073.jpg";